











import Vue, { VNode } from 'vue';
import { SwExtendedVue } from '../sw-extended-vue';
import { CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';

const cssPrefix = 'sw-dropdown-unit-divider';

export default Vue.extend({
  functional: true,
  props: {
    thickness: {
      type: Number,
      default: 2,
    },
    color: {
      type: String,
      default: utilService.colorConst.selected,
    },
  },
  /* tslint:disable-next-line */
  render(h, context) {
    const style: CSSStyleOptions = {
      height: `${context.props.thickness}px`,
      backgroundColor: context.props.color,
    };
    return (
      <div class={[`${cssPrefix}`]} style={style} {...context.data}></div>
    ) as VNode;
  },
}) as typeof SwExtendedVue;
